import { jsxs as r, Fragment as e, jsx as C } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ r(e, { children: [
  /* @__PURE__ */ C(
    "path",
    {
      d: "M12 7.5C11.1054 7.5 10.5 8.16081 10.5 8.83333V9.41667C10.5 9.96895 10.0523 10.4167 9.5 10.4167C8.94771 10.4167 8.5 9.96895 8.5 9.41667V8.83333C8.5 6.92853 10.1331 5.5 12 5.5C13.8669 5.5 15.5 6.92853 15.5 8.83333V8.97485C15.5 9.91955 15.0973 10.8104 14.4057 11.4559L13 12.7679V13.5C13 14.0523 12.5523 14.5 12 14.5C11.4477 14.5 11 14.0523 11 13.5V12.3333C11 12.0562 11.115 11.7914 11.3177 11.6023L13.0411 9.99379C13.344 9.71107 13.5 9.34288 13.5 8.97485V8.83333C13.5 8.16081 12.8946 7.5 12 7.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M12 15.75C11.3097 15.75 10.75 16.3097 10.75 17C10.75 17.6903 11.3097 18.25 12 18.25C12.6903 18.25 13.25 17.6903 13.25 17C13.25 16.3097 12.6903 15.75 12 15.75Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M12.2529 1C6.43856 1 1.72511 5.71345 1.72511 11.5278C1.72511 13.5415 2.29195 15.4262 3.27413 17.027L1.1961 19.1051C0.701787 19.5994 0.553916 20.3428 0.821434 20.9886C1.08895 21.6345 1.71918 22.0556 2.41824 22.0556H11.7353C11.7851 22.0556 11.8346 22.0534 11.8838 22.0492C12.0063 22.0534 12.1294 22.0556 12.2529 22.0556C18.0672 22.0556 22.7807 17.3421 22.7807 11.5278C22.7807 5.71345 18.0672 1 12.2529 1ZM3.72511 11.5278C3.72511 6.81802 7.54313 3 12.2529 3C16.9627 3 20.7807 6.81802 20.7807 11.5278C20.7807 16.2376 16.9627 20.0556 12.2529 20.0556C12.1308 20.0556 12.0094 20.053 11.8886 20.0479C11.831 20.0455 11.7734 20.0481 11.7163 20.0556H3.07401L5.26938 17.8602C5.61825 17.5113 5.66054 16.9602 5.36897 16.5621C4.33547 15.1514 3.72511 13.4115 3.72511 11.5278Z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  )
] });
export {
  t as default
};
